export default {
	notification(state, payload) {
		state.notificationContent = payload
	},
	setNotificationStatus(state, payload) {
		state.notificationStatus = payload;
	},
	setNotificationCount(state, payload) {
		state.notificationCount = payload
	}
};
